import React from "react";
import CommonGrid from "./CommonGrid";
import { ColumnType } from "../../../../components/Grid/constants";
import AssigneeDropdown from "../AssigneeDropdown";

const ControlBatchDetailGrid = function(props) {
    var onAssign = props.onAssign;
    var assignees = props.assignees;

    var rest = Object.assign({}, props);
    delete rest.onAssign;

    var columns = [
        {
            field: 'officialFirstName',
            displayField: 'official',
            label: 'Jméno',
            type: ColumnType.TEXT,
            mapper: function(field) { return field ? field.firstName : ''; },
            width: '33%',
        },
        {
            field: 'officialLastName',
            displayField: 'official',
            label: 'Příjmení',
            type: ColumnType.TEXT,
            mapper: function(field) { return field ? field.lastName : ''; },
            width: '33%',
        },
        {
            field: 'officialBirthDate',
            displayField: 'official',
            label: 'Datum narození',
            type: ColumnType.DATE,
            mapper: function(field) { return field ? field.birthDate : ''; },
            sortable: false,
            filterable: false,
            width: '15%',
        },
        {
            field: 'officialOrganizations',
            displayField: 'official',
            label: 'Organizace',
            type: ColumnType.TEXT,
            mapper: function(field) { return field ? field.concatenatedWorkingPositionOrganizations : ''; },
            sortable: true,
            filterable: true,
            width: '20%',
        },
        {
            field: 'officialFunctions',
            displayField: 'official',
            label: 'Funkce',
            type: ColumnType.TEXT,
            mapper: function(field) { return field ? field.concatenatedWorkingPositions : ''; },
            sortable: false,
            filterable: false,
            width: '20%',
        },
        {
            field: 'assignee.name',
            displayField: 'assignee',
            label: 'Vyřizuje',
            type: ColumnType.JSX,
            sortable: false,
            filterable: false,
            width: '34%',
            jsx: function(row) {
                var currentId = row.assignee ? row.assignee.id : '';
                return (
                    <AssigneeDropdown
                        value={currentId}
                        assignees={assignees}
                        onChange={function(assigneeId) {
                            if (onAssign) onAssign(row.id, assigneeId);
                        }}
                    />
                );
            },
        },
    ];

    return <CommonGrid {...rest} columns={columns} />;
};

export default ControlBatchDetailGrid;